export default {
  appbar: {
    signupButton: "Sign Up",
    loginButton: "Login"
  },
  loginPage: {
    title: "Login to Excoino",
    emailOrMobile: {
      label: "Mobile Number or Email",
      validation: "Entering mobile number or email is required"
    },
    mobile: {
      label: "Mobile Number",
      validation: "Entering mobile number is required"
    },
    email: {
      label: "Email",
      validation: "Entering email is required"
    },
    password: {
      label: "Password",
      validation: {
        notEmpty: "Entering password is required",
        notPersian: "Enter password in Latin characters"
      }
    },
    forgetPasswordLink: "Forgot your password?",
    loginButton: "Login",
    signUpBefore: "Haven't registered yet?",
    signUpBeforeLink: "Sign Up"
  },
  passwordRecoveryPage: {
    title: "Password Recovery",
    emailOrMobile: {
      label: "Mobile Number or Email",
      validation: "Entering mobile number or email is required"
    },
    passwordRecoveryButton: "Continue"
  },
  passwordRecoveryOTPPage: {
    title: "Password Recovery",
    subtitle: {
      part1: "To recover your password, enter the code sent to ",
      part2: ""
    },
    otpCode: {
      placeholder: "Verification Code",
      validation: "Entering verification code is required"
    },
    timeTitle: " Resend code in {count} seconds",
    passwordRecoveryOTPButton: "Continue",
    passwordRecoveryOTPResendButton: "Resend Verification Code"
  },
  passwordResetPage: {
    title: "Change Password",
    subtitle: "Enter your new password",
    password: {
      label: "Password",
      validation: {
        notEmpty: "Entering password is required",
        notPersian: "Enter password in Latin characters"
      }
    },
    passwordConfirm: {
      label: "Confirm Password",
      validation: "Entering password confirmation is required"
    },
    passwordResetButton: "Confirm",
    validationTitle: "Password Requirements:"
  },
  googleAuthPage: {
    title: "Google Authentication",
    subtitle: "Enter the 6-digit Google Authenticator code to login",
    otpCode: {
      placeholder: "Google Authenticator Code",
      validation: "Entering verification code is required"
    },
    googleAuthButton: "Confirm and Login"
  },
  emailAuthPage: {
    title: "Email Authentication",
    subtitle: {
      part1: "To login, please enter the code sent to (",
      part2: ")."
    },
    otpCode: {
      placeholder: "Verification Code",
      validation: "Entering verification code is required"
    },
    emailAuthButton: "Confirm and Login"
  },
  otpAuthPage: {
    title: "SMS Authentication",
    subtitle: {
      part1: "To login, please enter the code sent to (",
      part2: ")."
    },
    otpCode: {
      placeholder: "Verification Code",
      validation: "Entering verification code is required"
    },
    timeTitle: " Resend code in {count} seconds",
    otpAuthButton: "Confirm and Login",
    otpAuthResetButton: "Resend Verification Code"
  },
  registerPage: {
    title: "Sign Up for Excoino",
    emailOrMobile: {
      label: "Mobile Number or Email",
      validation: "Entering mobile number or email is required"
    },
    password: {
      label: "Password",
      validation: {
        notEmpty: "Entering password is required",
        notPersian: "Enter password in Latin characters"
      }
    },
    passwordConfirm: {
      label: "Confirm Password",
      validation: "Entering password confirmation is required"
    },
    referralCode: {
      title: "Referral Code (optional)",
      label: "Referral Code"
    },
    policyLink: "I agree with the terms and conditions",
    policyTitle: "of Excoino.",
    signUpButton: "Continue",
    signInBefore: "Already registered?",
    signInBeforeLink: "Login",
    validationTitle: "Password Requirements:"
  },
  registerVerificationPage: {
    title: "Sign Up for Excoino",
    subtitle: {
      part1: "To sign up for Excoino, please enter the code sent to",
      part2: "."
    },
    verificationCode: {
      placeholder: "Verification Code",
      validation: "Entering verification code is required"
    },
    timeTitle: " Resend code in {count} seconds",
    verificationButton: "Sign Up and Login",
    verificationResetButton: "Resend Verification Code"
  },
  registerConfirmedPage: {
    title: "Your Excoino account has been created.",
    subtitle:
      "You will be automatically redirected to the login page in {count} seconds.",
    goToLoginButton: "Login and Complete Authentication",
    completeAuth:
      "To use all features of Excoino, complete your authentication."
  },
  emailVerifiedPage: {
    title: "Your email has already been verified.",
    subtitle: {
      part1: "If you have any questions, contact",
      part2: "support.",
      linkTitle: "support"
    },
    emailVerifiedButton: "Login to Account"
  },
  emailSuccessPage: {
    title: "Your email has been verified",
    subtitle: "You can now login to your account.",
    emailSuccessButton: "Login to Account"
  },
  emailInvalidPage: {
    title: "Invalid Activation Link",
    subtitle: {
      part1: "If you have any questions, contact",
      part2: "support.",
      linkTitle: "support"
    },
    emailInvalidButton: "Login to Account"
  },
  disableGaPage: {
    title: "Disabling Google authentication",
    description:
      "Dear user, if you do not have access to your two-factor ID, you can remove it from your account through this page. Also, if you complete this process and remove your two-factor ID, your account's cryptocurrency withdrawals will be limited for 72 hours.",
    disableGA: "Disabling Google Authenticator (Google Authenticator)",
    loginButton: "Confirmation and login",
    otpCode: {
      placeholder: "Verification code"
    },
    loginToExcoino: "Login to Excoino",
    successMessage: "Google authentication has been disabled successfully.",
    email: "Email",
    mobile: "Mobile",
    forRegisterOtp: "To register, enter the code sent to {count}"
  }
};
